module.exports = __webpack_public_path__ + "static/media/trip_key_9.706dbce8.png";